import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import CustomMasonryHero from './components/CustomMasonryHero';
import ServiceFeatures from './components/ServiceFeatures';
import QuoteForm from './components/QuoteForm';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lgconcretepumping.com';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': `${SITE_URL}/services/custom-masonry#service`,
  name: 'Custom Masonry Services',
  url: `${SITE_URL}/services/custom-masonry`,
  description:
    'Tailored masonry solutions including custom designs, specialty finishes, and expert repair and restoration in Western NC. LG Concrete Pumping & Stone LLC.',
  provider: { '@id': `${SITE_URL}/#business` },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Western North Carolina' },
    { '@type': 'AdministrativeArea', name: 'North Georgia' },
    { '@type': 'AdministrativeArea', name: 'Southwest South Carolina' },
  ],
  serviceType: 'Custom Masonry',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Custom Masonry Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Custom Masonry Design' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Specialty Finishes' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Masonry Repair & Restoration' } },
    ],
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_URL}/services` },
    { '@type': 'ListItem', position: 3, name: 'Custom Masonry', item: `${SITE_URL}/services/custom-masonry` },
  ],
};

const CustomMasonryPage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    [serviceSchema, breadcrumbSchema].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Custom Masonry Services | LG Concrete Pumping & Stone LLC Otto NC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Custom masonry designs, specialty finishes, and expert repair in Western NC. LG Concrete Pumping & Stone LLC, Otto NC. Call (828) 634-1304.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/services/custom-masonry`);

    return () => { scripts.forEach((s) => s.remove()); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CustomMasonryHero />
      <ServiceFeatures />
      <QuoteForm />
      <Footer />
    </div>
  );
};

export default CustomMasonryPage;
